<template>
  <div
    id="staff-view"
    class="pa-4"
  >
    <view-page-header :show-team-select="false" />

    <section>
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <div class="subtitle-2">
            {{ $t('table_title.organization_staff') }}
          </div>
        </v-card-title>
        <v-card-text class="pa-0">
          <staff-list-table
            :staff="staff.data"
            :loading="staff.loading"
            :pagination="staff.pagination"
            @edit="onEditCoach($event)"
          />
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import StaffListTable from '@/components/staff/StaffListTable'
import { CoachApiService } from '@/data/services'
import debounce from 'lodash/debounce'
import ViewPageHeader from '@/components/ViewPageHeader'
import { EventBus } from '@/plugins/bus'

export default {
  name: 'AdminStaffView',
  components: { ViewPageHeader, StaffListTable },
  data: () => ({
    staff: {
      data: [],
      loading: false,
      pagination: {
        current_page: null,
        last_page: null,
        per_page: 25
      }
    }
  }),
  computed: {
    currentTeam() {
      return this.$store.getters[this.$storeGetters.APP_CURRENT_TEAM]
    }
  },
  watch: {
    'staff.pagination.current_page': function (newVal, oldVal) {
      this.fetchStaffList()
    },
    currentTeam() {
      this.staff.pagination = {
        current_page: null,
        last_page: null,
        per_page: 25
      }
      this.fetchStaffList()
    }
  },
  created() {
    this.staff.loading = true

    this.initPagination()

    EventBus.$on(this.$events.COACH_CREATED, () => this.fetchStaffList())
    EventBus.$on(this.$events.COACH_UPDATED, () => this.fetchStaffList())
    EventBus.$on(this.$events.COACH_DELETED, () => this.fetchStaffList())
  },
  methods: {
    initPagination() {
      this.staff.pagination.current_page = typeof this.$route.query.page === 'string' ? parseInt(this.$route.query.page) : 1
    },
    fetchStaffList: debounce(async function() {
      try {
        this.staff.loading = true

        const queryParams = {
          page: this.staff.pagination.current_page,
          per_page: this.staff.pagination.per_page,
          team_id: this.currentTeam?.id
        }

        const response = await CoachApiService.getPaginated(queryParams)

        this.staff.data = response.data
        this.staff.pagination = response.meta
        // eslint-disable-next-line no-useless-catch
      } catch (e) {
        throw e
      } finally {
        this.staff.loading = false
      }
    }, 500),
    onEditCoach(coach) {
      EventBus.$emit(this.$events.EDIT_COACH, coach)
    }
  }
}
</script>
